import { ImplementationStateStatusValueType } from './valueTypes/ImplementationStateStatusValueType';
import { StatusValueNoneStatusValue } from './valueTypes/StatusValueNoneStatusValue';

export const StatusValueSystemType = {
  ...ImplementationStateStatusValueType,
  ...StatusValueNoneStatusValue,
};
